import Component from "@glimmer/component";
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { Task, restartableTask, timeout } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { func, instanceOf } from "prop-types";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

import TaskForm from "glesys-controlpanel/components/task-form";
import GInput from "glesys-controlpanel/components/g-input";
import GButton from "glesys-controlpanel/components/g-button";
import { t } from "ember-intl";
import { eq, or } from "ember-truth-helpers";
import { on } from "@ember/modifier";

@forbidExtraArgs
export default class extends Component {
  @arg(instanceOf(Task)) searchTask;
  @arg(stringable) searchQuery = "";
  @arg(func.isRequired) onChange;

  @tracked error = false;

  get searchQueryIsTooShort() {
    return this.searchQuery.length > 0 && this.searchQuery.length < 3;
  }

  @action
  onClick(event) {
    this.error = false;
    if (this.searchQuery.length < 3) {
      this.error = true;
      event.preventDefault();
    }
  }

  @action
  onInputChange(event) {
    this.onChange(event.target.value);
    this.debounce.perform();
  }

  debounce = restartableTask(async () => {
    if (this.searchQueryIsTooShort) {
      if (ENV.environment !== "test") {
        await timeout(1000);
      }
      this.error = true;
    } else {
      this.error = false;
    }
  });

  <template>
    <TaskForm class="mb-3" @task={{this.searchTask}} {{mergeClasses}} ...attributes>
      <div class="w-full flex">
        <div class="grow mr-4">
          <GInput
            class="mb-0"
            data-test-search-field
            value={{this.searchQuery}}
            placeholder={{t "dns.register.search-hint"}}
            disabled={{this.searchTask.isRunning}}
            {{on "input" this.onInputChange}}
          />
        </div>
        <GButton
          data-test-check-availability
          @type="submit"
          @color="outline"
          @disabled={{or this.searchQueryIsTooShort (eq this.searchQuery "")}}
          {{on "click" this.onClick}}
        >
          {{t "dns.search.button"}}
        </GButton>
      </div>
    </TaskForm>
    {{#if this.error}}
      <span class="block text-xs text-left -mt-2 mb-3 text-red" data-test-message>
        {{t "dns.register.search-warning"}}
      </span>
    {{/if}}
  </template>
}
